import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';


export const ELEVE_OPEN_SHOW = 'ELEVE_OPEN_SHOW';
export const ELEVE_CLEAR = 'ELEVE_CLEAR';
export const ELEVE_CLEAR_SEARCH = 'ELEVE_CLEAR_SEARCH';
export const ELEVE_OPEN_EDIT = 'ELEVE_OPEN_EDIT';
export const ELEVE_OPEN_SHOW_SUCCESS = 'ELEVE_OPEN_SHOW_SUCCESS';
export const ELEVE_OPEN_EDIT_SUCCESS = 'ELEVE_OPEN_EDIT_SUCCESS';

export const ELEVE_SEARCH = 'ELEVE_SEARCH';
export const ELEVE_CREATE = 'ELEVE_CREATE';
export const ELEVE_UPDATE = 'ELEVE_UPDATE';
export const ELEVE_DELETE = 'ELEVE_DELETE';
export const ELEVE_ABSENCE_CREATE = 'ELEVE_ABSENCE_CREATE';
export const ELEVE_ABSENCE_UPDATE = 'ELEVE_ABSENCE_UPDATE';
export const ELEVE_ABSENCE_DELETE = 'ELEVE_ABSENCE_DELETE';

export const ELEVE_SEARCH_SUCCESS = 'ELEVE_SEARCH_SUCCESS';
export const ELEVE_CREATE_SUCCESS = 'ELEVE_CREATE_SUCCESS';
export const ELEVE_UPDATE_SUCCESS = 'ELEVE_UPDATE_SUCCESS';
export const ELEVE_DELETE_SUCCESS = 'ELEVE_DELETE_SUCCESS';
export const ELEVE_ABSENCE_CREATE_SUCCESS = 'ELEVE_ABSENCE_CREATE_SUCCESS';
export const ELEVE_ABSENCE_UPDATE_SUCCESS = 'ELEVE_ABSENCE_UPDATE_SUCCESS';
export const ELEVE_ABSENCE_DELETE_SUCCESS = 'ELEVE_ABSENCE_DELETE_SUCCESS';

export const ELEVE_ERROR = 'ELEVE_ERROR';


export const EleveActions = {

    clear: ({id, errorCallback}) => {
        return {
            type: ELEVE_CLEAR,
            payload: {id, errorCallback},
        };
    },

    clearSearch: ({errorCallback}) => {
        return {
            type: ELEVE_CLEAR_SEARCH,
            payload: {errorCallback},
        };
    },

    openShow: ({http, eleve, absence, inscription, famille, examen, params: {anneeScolaire, id}, errorCallback}) => {
        return {
            type: ELEVE_OPEN_SHOW,
            payload: {http, eleve, absence, inscription, famille, examen, params: {anneeScolaire, id}, errorCallback}
        };
    },

    openEdit: ({http, model, params, successCallback, errorCallback}) => {
        return {
            type: ELEVE_OPEN_EDIT,
            payload: {http, model, params, successCallback, errorCallback}
        };
    },

    update: ({http, model, form, params, successCallback, errorCallback}) => {
        return {
            type: ELEVE_UPDATE,
            payload: {http, model, form, params, successCallback, errorCallback}
        };
    },
    search: ({http, model, form, params, errorCallback}) => {
        return {
            type: ELEVE_SEARCH,
            payload: {http, model, form, params, errorCallback}
        };
    },
    create: ({http, model, form, params, successCallback, errorCallback} ) => {
        return {
            type: ELEVE_CREATE,
            payload: {http, model, form, params, successCallback, errorCallback}
        };
    },
    delete: ({http, model, params, successCallback, errorCallback}) => {
        return {
            type: ELEVE_DELETE,
            payload: {http, model, params, successCallback, errorCallback}
        };
    },

    createAbsence: ({http, model, form, successCallback, errorCallback}) => {
        return {
            type: ELEVE_ABSENCE_CREATE,
            payload: {http, model, form, successCallback, errorCallback},
        };
    },
    updateAbsence: ({http, model, form, successCallback, errorCallback}) => {
        return {
            type: ELEVE_ABSENCE_UPDATE,
            payload: {http, model, form, successCallback, errorCallback},
        };
    },
    deleteAbsence: ({http, model, eleveId, params, errorCallback}) => {
        return {
            type: ELEVE_ABSENCE_DELETE,
            payload: {http, model, eleveId, params, errorCallback},
        };
    },
};


export const EleveEpics = [

    // CREATE ABSENCE
    ($action, store) => {
        return $action.ofType(ELEVE_ABSENCE_CREATE).mergeMap(action => {
            const {http, model, form, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'save')
            .call(http, form)
            .map(data => {
                successCallback(data);
                return {
                    type: ELEVE_ABSENCE_CREATE_SUCCESS,
                    payload: {...form.value, id: data},
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });
        });
    },

    // UPDATE ABSENCE
    ($action, store) => {
        return $action.ofType(ELEVE_ABSENCE_UPDATE).mergeMap(action => {
            const {http, model, form, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'post')
            .call(http, 'updateExcuseMotif', form)
            .map(data => {

                if (data > 0) {
                    successCallback(data);
                    return {
                        type: ELEVE_ABSENCE_UPDATE_SUCCESS,
                        payload: {id: data, ...form.value}
                    };
                } else {
                    errorCallback();
                    return {
                        type: ELEVE_ERROR,
                    };
                }
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });
        });
    },

    // DELETE ABSENCE
    ($action, store) => {
        return $action.ofType(ELEVE_ABSENCE_DELETE).mergeMap(action => {
            const {http, model, eleveId, params, errorCallback} = action.payload;

            return model.getResource('default', 'get')
            .call(http, 'deleteById', params)
            .map(data => {
                return {
                    type: ELEVE_ABSENCE_DELETE_SUCCESS,
                    payload: {id: params[0], eleveId }
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });
        });
    },

    // ELEVE OPEN SHOW
    ($action, store) => {
        return $action.ofType(ELEVE_OPEN_SHOW).mergeMap(action => {

            const {http, eleve, absence, inscription, famille, examen, params: {anneeScolaire, id}, errorCallback} = action.payload;

            return eleve.getResource('default', 'get').call(http, 'findById', [id, anneeScolaire])
            .flatMap((baseEleve) => {
                return Observable.forkJoin(
                    absence.getResource('default', 'get').call(http, 'findByEleveId', [id, anneeScolaire]),
                    inscription.getResource('default', 'get').call(http, 'findByEleveId', [id, 0, anneeScolaire]),
                    famille.getResource('default', 'get').call(http, 'findById', [baseEleve['famille'].id, anneeScolaire])
                        .map((lfamille) => {
                            // Adds info famille
                            baseEleve.famille = lfamille;
                            return baseEleve;
                        }),
                    eleve.getResource('default', 'get').call(http, 'findByFamilleId', [baseEleve['famille'].id, anneeScolaire]),
                    examen.getResource('default', 'get').call(http, 'searchHistorique', [id, anneeScolaire]),
                );
            })
            .map((data) => {
                const [absences, inscriptions, baseEleve, eleves, examens] = data;
                console.log('Resultat recherche eleve', id, data);
                baseEleve['famille'] = {...baseEleve.famille, eleves};
                baseEleve['absences'] = absences;
                baseEleve['inscriptions'] = inscriptions;
                baseEleve['examens'] = examens;

                return {
                    type: ELEVE_OPEN_SHOW_SUCCESS,
                    payload: baseEleve
                };

            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });
        });
    },

    // ELEVE OPEN EDIT
    ($action, store) => {
        return $action.ofType(ELEVE_OPEN_EDIT).mergeMap(action => {

            const {http, model, params, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'get')
            .call(http, 'findById', params)
            .map(data => {
                successCallback(data);
                return {
                    type: ELEVE_OPEN_EDIT_SUCCESS,
                    payload: data
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });
        });
    },

    // ELEVE UPDATE
    ($action, store) => {
        return $action.ofType(ELEVE_UPDATE).mergeMap(action => {


            const {http, model, form, params, successCallback, errorCallback} = action.payload;
            console.log('ELEVE UPDATE', {model, form, params});

            return model.getResource('default', 'update')
            .call(http, form, params)
            .map(data => {
                successCallback(data);
                return {
                    type: ELEVE_UPDATE_SUCCESS,
                    payload: {...form.value},
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });
        });
    },

    // ELEVE SEARCH
    ($action, store) => {
        return $action.ofType(ELEVE_SEARCH).mergeMap(action => {
            const {http, model, form, params, errorCallback} = action.payload;
            let stream = null;
            if (form.controls['id'].value) {
                stream = model.getResource('default', 'get')
                .call(http, 'findById', params);
            } else {
                stream = model.getResource('default', 'find')
                .call(http, form, []);
            }
            return stream.map((data) => {
                if (form.controls['id'].value) {
                    return {
                        type: ELEVE_SEARCH_SUCCESS,
                        payload: [data],
                    };
                } else {
                    return {
                        type: ELEVE_SEARCH_SUCCESS,
                        payload: data,
                    };
                }
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });
        });
    },

    // ELEVE CREATE
    ($action, store) => {
        return $action.ofType(ELEVE_CREATE).mergeMap(action => {

            const {http, model, form, params, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'save')
            .call(http, form, params)
            .map(data => {
                successCallback(data);
                return {
                    type: ELEVE_CREATE_SUCCESS,
                    payload: data
                };
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });

        });
    },

    // ELEVE DELETE
    ($action, store) => {
        return $action.ofType(ELEVE_DELETE).mergeMap(action => {
            const {http, model, params, successCallback, errorCallback} = action.payload;

            return model.getResource('default', 'delete')
            .call(http, params)
            .map(data => {

                if (data > 0) {
                    successCallback(data);
                    return {
                        type: ELEVE_DELETE_SUCCESS,
                        payload: {id: params[0]}
                    };
                } else {
                    errorCallback(data);
                    return {
                        type: ELEVE_ERROR,
                        payload: data
                    };
                }
            })
            .catch(error => {
                errorCallback(error);
                return Observable.of({
                    type: ELEVE_ERROR,
                    error,
                });
            });
        });
    },

];


const initialState = {
    absenceLoading: false,
    loading: false,
    list: null,
    edit: null,
    show: null,
    searchForm: null,
};

export const EleveReducer = (state = initialState, action: any) => {

    let eleveId = null;

    switch (action.type) {

        case ELEVE_SEARCH:
            return {...state,
                loading: true,
                searchForm: action.payload.form,
            };
        case ELEVE_CREATE:
        case ELEVE_UPDATE:
        case ELEVE_OPEN_SHOW:
        case ELEVE_OPEN_EDIT:
            return {...state, loading: true};
        case ELEVE_CLEAR:
            return {...state,
                loading: false,
                edit: {...state.edit, [action.payload.id]: null},
                show: {...state.show, [action.payload.id]: null}
            };
        case ELEVE_CLEAR_SEARCH:
            return {...state,
                loading: false,
                searchForm: null,
                list: null,
            };
        case ELEVE_ABSENCE_CREATE:
        case ELEVE_ABSENCE_UPDATE:
        case ELEVE_ABSENCE_DELETE:
            return {...state, absenceLoading: true};

        case ELEVE_SEARCH_SUCCESS:
            return {...state, loading: false, list: action.payload};
        case ELEVE_CREATE_SUCCESS:
            return {...state, loading: false};
        case ELEVE_UPDATE_SUCCESS:
            return {...state, loading: false,
                edit: {...state.edit, [action.payload.id]: null},
                show: {...state.edit, [action.payload.id]: null}
            };
        case ELEVE_DELETE_SUCCESS:
            return {...state, loading: false,
                list: state.list ? state.list.filter(eleve => eleve.id !== action.payload.id) : null,
                show: {...state.show, [action.payload.id]: null},
                edit: {...state.edit, [action.payload.id]: null},
            };

        case ELEVE_ABSENCE_CREATE_SUCCESS:
            eleveId = action.payload.eleveId;
            return {...state,
                absenceLoading: false,
                show: {...state.show, [eleveId]: {
                    ...state.show[eleveId],
                    absences: [...state.show[eleveId].absences, action.payload]
                }}
            };

        case ELEVE_ABSENCE_UPDATE_SUCCESS:
            eleveId = action.payload.eleveId;
            return {...state,
                absenceLoading: false,
                show: {...state.show, [eleveId]: {
                    ...state.show[eleveId],
                    absences: state.show[eleveId].absences ? state.show[eleveId].absences.map(absence => {
                        return +absence.id === +action.payload.id ? action.payload : absence;
                    }) : null,
                }}
            };

        case ELEVE_ABSENCE_DELETE_SUCCESS:
            eleveId = action.payload.eleveId;
            return {...state,
                absenceLoading: false,
                show: {...state.show, [eleveId]: {
                    ...state.show[eleveId],
                    absences: state.show[eleveId].absences.filter(absence => absence.id !== action.payload.id)
                }}
            };


        case ELEVE_OPEN_EDIT_SUCCESS:
            return {...state,
                loading: false,
                edit: {...state.edit, [action.payload.id]: action.payload}
            };

        case ELEVE_OPEN_SHOW_SUCCESS:
            return {...state,
                loading: false,
                show: {...state.show, [action.payload.id]: action.payload}
            };

        case ELEVE_ERROR:
            return {...state, loading: false};

        default:
            return state;
    }

};



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/eleve/models/eleve.store.ts